<template>


    <app-layout :title="__('Ad')">


        <div class="">


            <div class="max-w-[1200px] mx-auto sm:px-6 lg:px-8 pb-64">


                <div class="">


                    <div class="grid grid-cols-2"
                        style="grid-template-rows:  repeat(auto-fill, max-content);
                        grid-row-gap: 15px">


                        <div class="mb-[15px] mt-[31px] row-start-1 flex items-end">


                            <h1 class="text-2xl font-nexa text-dark-blue leading-[24px]"
                                style="height: 30px">

                                Create Ad

                            </h1>


                        </div>


                        <div class="mb-[15px] mt-[31px] leading-[24px] row-start-1 items-center
                                    justify-self-end self-center flex">


                            <div class="px-6 py-1 bg-dark-blue items-center flex justify-center shadow-sm
                                        cursor-pointer mr-4">


                                <h1 class="mb-[2px] font-nexa text-white"
                                    @click="handle_click_on_preview">

                                    Preview

                                </h1>


                                <font-awesome-icon
                                    class="ml-2 text-white"
                                    style="width: 16px; height: 16px;"
                                    size="sm"
                                    :icon="['fas', 'external-link']" />


                            </div>


                            <h1 class="text-sm ml-1 font-nexa text-white text-[#9E9E9E]">

                                Last changed: {{ updated_at }}

                            </h1>


                        </div>


                        <flash-message v-if="$page.props.flash.message" :message="$page.props.flash.message"
                                       classes="text-green mb-4"/>


                        <div class="col-span-2 bg-white grid items-center"
                             style="grid-template-columns: 30px 147px 30px 600px auto;"
                             :style="`grid-template-rows: 18px auto 18px 2px 18px auto 18px 2px 18px auto 18px 2px 18px auto 18px 2px 18px auto 18px ${language_dropdown};`">


                            <template v-for="(row,index) in 3">


                                <h3 class="col-span-1 col-start-2 row-start-2 leading-[16px]">

                                     Ad Title

                                </h3>


                                <input class="h-[50px] border border-light-grey h-full
                                    col-span-1 col-start-4 row-start-2"
                                       v-model="form.ad_title"
                                       type="text">


                                <div class="border-b border-lighter-grey col-span-5 row-start-4" />


                                <div class="row-start-6 col-start-2">

                                    Status all Languages

                                </div>


                                <div class="row-start-6 col-start-4">

                                    <dropdown class="w-[243px] h-[50px] border border-light-grey col-start-4
                                            row-start-[26] cursor-pointer"
                                              content-classes="w-[243px] bg-white"
                                              width="[240px]"
                                              align="left"
                                              type="text">


                                        <template #trigger>


                                            <div class="mt-auto mb-[6px]">

                                                {{ status_as_text(form.status_all) }}

                                            </div>


                                            <font-awesome-icon
                                                class="justify-center font-bold ml-auto my-auto w-[13px] h-[18px]"
                                                size="sm"
                                                :icon="['fas', 'caret-down']" />


                                        </template>


                                        <template #content>


                                            <div class="py-2 px-4 cursor-pointer hover:bg-gray-300"
                                                 v-if="form.status_all !== 'active' || form.status_all === 'new'"
                                                 @click="handle_all_status(form.status_all)">

                                                Active

                                            </div>


                                            <div class="py-2 px-4 cursor-pointer hover:bg-gray-300"
                                                 v-if="form.status_all !== 'paused' && form.status_all !== null
                                                  || form.status_all === 'new'"
                                                 @click="handle_all_status(form.status_all)">

                                                Paused

                                            </div>


                                        </template>


                                    </dropdown>


                                </div>


                                <div class="border-b border-lighter-grey col-span-5 row-start-[8]" />


                                <div class="row-start-[10] col-start-2">

                                    Organization

                                </div>

                                <div class="row-start-[10] col-start-4">

                                    <dropdown class="w-[293px] h-[50px] border border-light-grey col-start-4
                                              cursor-pointer"
                                              content-classes="w-[293px] bg-white"
                                              width="[240px]"
                                              align="left"
                                              type="text">


                                        <template #trigger>


                                            <div class="mt-auto mb-[6px]">

                                                {{ organization_as_text( form.organization ) }}

                                            </div>


                                            <font-awesome-icon
                                                class="justify-center font-bold ml-auto my-auto w-[13px] h-[18px]"
                                                size="sm"
                                                :icon="['fas', 'caret-down']" />


                                        </template>


                                        <template #content>


                                            <div class="py-2 px-4 cursor-pointer hover:bg-gray-300"
                                                 v-if="form.organization === 'the_nordic_council'"
                                                 @click="handle_organization( form.organization )">

                                                The Nordic Council of Ministers

                                            </div>


                                            <div class="py-2 px-4 cursor-pointer hover:bg-gray-300"
                                                 v-if="form.organization === 'the_nordic_council_of_ministers'"
                                                 @click="handle_organization( form.organization )">

                                                The Nordic Council

                                            </div>


                                        </template>


                                    </dropdown>


                                </div>

                                <div class="border-b border-lighter-grey col-span-5 row-start-[12]" />


                                <h3 class="col-start-2 row-start-[14]">

                                    Period*

                                </h3>


                                <div class="flex items-center col-start-4 row-start-[14]">


                                    <range-picker class="flex w-auto"
                                                  :start_at="period.start_at"
                                                  :end_at="period.end_at"
                                                  @start_at_changed="handle_period_start_change"
                                                  @end_at_changed="handle_period_end_change" />


                                </div>


                                <div class="border-b border-lighter-grey col-span-5 row-start-[16]" />


                                <h3 class="col-span-1 col-start-2 row-start-[18] leading-[16px]">

                                    Ad Language

                                </h3>


                                <div class="col-span-1 col-start-4 row-start-[18] flex justify-between items-center
                                            h-[50px]">


                                    <div class="flex pl-[4px]">


                                        <div class="ring-offset-4 ring-blue mr-6 rounded-full"
                                             v-for="language in languages"
                                             :key="language.id"
                                             :class="[
                                                 language.is_selected ? 'ring-2' : ''
                                             ]"
                                             @click="handle_click_save(form, route('ad', {
                                                ad: language.ad_id,
                                                language: language.src
                                             }))">


                                            <img class="w-[26px] h-auto cursor-pointer"
                                                 :src="`/images/flag-${language.src}.png`"
                                                 alt="Flag" />


                                        </div>


                                    </div>


                                    <div class="items-center justify-self-end
                                                flex mr-2 cursor-pointer"
                                         @click="handle_delete_language( form )">


                                        <font-awesome-icon
                                            class="font-bold ml-auto my-auto mr-2 w-[14px] h-[14px] text-[#CE1515]"
                                            size="sm"
                                            :icon="['far', 'trash']" />


                                        <h1 class="text-sm ml-1 font-nexa  text-[#CE1515]">

                                            {{
                                                (are_you_sure_language)
                                                    ? 'Are you sure?'
                                                    : 'Delete Language'
                                            }}

                                        </h1>


                                    </div>


                                </div>


                                <div class="border-b border-lighter-grey col-span-5 row-start-[20]"
                                     v-if="languages_duplicatable != ''"/>


                                <h3 class="col-span-1 col-start-2 row-start-[22] leading-[16px]"
                                    v-if="languages_duplicatable != ''">

                                    New Ad Language

                                </h3>


                                <dropdown class="w-[228px] h-[36px] border border-light-grey cursor-pointer
                                                 self-center row-start-[22] my-[8px] col-span-1 col-start-4"
                                          v-if="languages_duplicatable != ''"
                                          content-classes="w-[228px] bg-white"
                                          width="[240px]"
                                          align="left"
                                          margin_top="mt-0">


                                    <template #trigger>


                                        <font-awesome-icon
                                            class="justify-center text-blue font-bold
                                                   my-auto mx-2 w-[20px] h-[20px]"
                                            size="sm"
                                            :icon="['far', 'plus-circle']" />


                                        <div class="my-auto text-[11.2px] leading-[18px]">

                                            Duplicate to a new language

                                        </div>


                                        <font-awesome-icon
                                            class="justify-center font-bold ml-auto my-auto mx-2 w-[13px] h-[18px]"
                                            size="sm"
                                            :icon="['fas', 'caret-down']" />


                                    </template>


                                    <template #content>


                                        <div class="flex items-center py-[5px] px-[10px] cursor-pointer
                                                    hover:bg-gray-300"
                                             v-for="language of languages_duplicatable"
                                             @click="handle_click_duplicate_to_new_language( language );">


                                            <img class="w-[26px] h-auto mr-[10px]"
                                                 :src="`/images/flag-${language.letter_code}.png`"
                                                 alt="Flag" />


                                            <div class="text-sm text-black">

                                                {{ language.title }}

                                            </div>


                                        </div>


                                    </template>


                                </dropdown>


                            </template>


                        </div>


                        <div class="col-span-2 bg-white grid items-center"
                             style="grid-template-columns: 30px 147px 30px 600px auto;
                             grid-template-rows: repeat(8, 18px auto 18px 2px);">


                            <h3 class="col-start-2 row-start-2">

                                Title*

                            </h3>


                            <input class="w-full border border-light-grey h-[50px] col-span-1 col-start-4 row-start-2"
                                   v-model="form.title"
                                   type="text">


                            <div class="border-b col-span-5 row-start-4" />


                            <h3 class="mb-auto mt-2 col-start-2 row-start-6">

                                Image <br>
                                600 px width

                            </h3>


                            <div class="flex flex-wrap col-start-4 row-start-6">

                                <!--
                                <div class="w-[600px] h-auto border border-light-grey bg-contain bg-no-repeat"
                                :style="`background-image: url(${image_display});`"
                                alt="Ad Image" />
                                -->

                                <img class="w-[600px] h-auto border border-light-grey bg-contain bg-no-repeat"
                                     :src="image_display"
                                     alt="Ad Image" />


                                <form class="my-4"
                                    v-show="! this.file"
                                    enctype="multipart/form-data">

                                    <label class="my-4 text-blue cursor-pointer" for="image_upload">

                                        Upload Image

                                        <input class="hidden"
                                            id="image_upload"
                                            @change="onFileChange"
                                            name="image_upload"
                                            type="file"
                                            accept="image/jpeg, image/png" />

                                    </label>


                                </form>


                                <h3 class="my-4 ml-6 text-[#CE1515] cursor-pointer"
                                    :class="{
                                        'hidden': ! this.form.image
                                    }"
                                    @click="handle_click_delete_image">

                                    Delete

                                </h3>


                            </div>


                            <div class="border-b col-span-5 row-start-[8]" />


                            <h3 class="mb-auto mt-2 col-start-2 row-start-[10]">

                                Text

                            </h3>


                            <div class="w-full border border-light-grey col-start-4 row-start-[10] h-auto">


                                <editor
                                    v-model="form.html"
                                    :initialValue="form.html"
                                    :apiKey="api_key"
                                    :init="{
                                          height: 300,
                                          menubar: false,
                                          plugins: [
                                            'advlist autolink lists link image charmap',
                                            'searchreplace visualblocks code fullscreen',
                                            'print preview anchor insertdatetime media',
                                            'paste code help wordcount table'
                                          ],
                                          toolbar: `undo redo h1 h2 h3 fontsizeselect bold italic forecolor alignleft aligncenter alignright | styleselect strikethrough selectall removeformat remove paste outdent newdocument language indent fontselect cut copy blockquote`
                                        }">


                                </editor>


                            </div>


                            <div class="border-b col-span-5 row-start-[12]" />


                            <h3 class="col-start-2 row-start-[14]">

                                Text Color

                            </h3>


                            <div class="col-start-4 row-start-[14] w-full flex justify-center items-center">

                                <status-combo-box class="w-[300px] h-full"
                                    :colors="this.predefined_colors"
                                    :selected_color="form.text_color"
                                    @change="(value) => color_change(value, 'text')" />


                                <div class="ml-auto mr-6 h-[40px] w-[150px] rounded-l-full cursor-pointer
                                            rounded-r-full justify-center items-center flex bg-[#ECEDEE]"
                                     :class="[
                                             {
                                                 'ring-2 ring-offset-4':
                                                  form.is_text_color_custom
                                             },]"
                                     @click="custom_change('text')">


                                    <span class="text-[16px] leading-[15px]">

                                        Custom: {{ text_color_picker }}

                                    </span>

                                </div>


                                <input class="w-[40px] justify-self-end border border-light-grey h-[40px]"
                                       v-model="text_color_picker"
                                       type="color" />

                            </div>


                            <div class="border-b col-span-5 row-start-[16]" />


                            <h3 class="col-start-2 row-start-[18]">

                                Background Color

                            </h3>


                            <div class="col-start-4 row-start-[18] flex">


                                <status-combo-box class="w-[300px] h-full"
                                                  :colors="this.predefined_colors"
                                                  :selected_color="form.background_color"
                                                  @change="(value) => color_change(value, 'background')" />


                                <div class="ml-auto mr-6 h-[40px] w-[150px] rounded-l-full cursor-pointer
                                            rounded-r-full justify-center items-center flex bg-[#ECEDEE]"
                                     :class="[{
                                                 'ring-2 ring-offset-4':
                                                  form.is_background_color_custom
                                             }]"
                                     @click="custom_change('background')">

                                    <span class="text-[16px] leading-[15px]">

                                        Custom: {{ background_color_picker }}

                                    </span>

                                </div>


                                <input class="w-[40px] justify-self-end border border-light-grey h-[40px]"
                                       v-model="background_color_picker"
                                       type="color" />

                            </div>


                            <div class="border-b col-span-5 row-start-[20]" />


                            <h3 class="col-start-2 row-start-[22]">

                                Link*

                            </h3>


                            <input class="w-full border border-light-grey col-start-4 row-start-[22] h-[50px]"
                                   v-model="form.link"
                                   type="text">



                            <div class="border-b col-span-5 row-start-[24]" />


                            <h3 class="col-start-2 row-start-[26]">

                                Status*

                            </h3>


                            <dropdown class="w-[243px] h-[50px] border border-light-grey col-start-4 row-start-[26]
                                            cursor-pointer"
                                      content-classes="w-[243px] bg-white"
                                      width="[240px]"
                                      align="left"
                                      type="text">


                                <template #trigger>


                                    <div class="mt-auto mb-[6px]">{{ status_as_text(form.status) }}</div>


                                    <font-awesome-icon
                                        class="justify-center font-bold ml-auto my-auto w-[13px] h-[18px]"
                                        size="sm"
                                        :icon="['fas', 'caret-down']" />


                                </template>


                                <template #content>


                                    <div class="py-2 px-4 cursor-pointer hover:bg-gray-300"
                                         v-if="form.status !== 'active' || form.status === 'new'"
                                         @click="handle_status(form.status)">

                                        Active

                                    </div>


                                    <div class="py-2 px-4 cursor-pointer hover:bg-gray-300"
                                         v-if="form.status !== 'paused' || form.status === 'new'"
                                         @click="handle_status(form.status)">

                                        Paused

                                    </div>


                                </template>


                            </dropdown>


                            <div class="border-b col-span-5 row-start-[28]" />


                        </div>


                        <div class="my-4">


                            <h1 class="text-2xl font-nexa text-dark-blue h-[30px] leading-[24px]">

                                Campaign Placement

                            </h1>


                        </div>


                        <div class="col-span-2 bg-white grid items-center h-[115px]"
                             style="grid-template-columns: 30px 147px 30px 243px 30px 243px 30px auto 30px;
                             grid-template-rows: 18px auto 18px;"
                             v-for="placement of placements">


                            <h3 class="col-start-2 row-start-2">

                                Campaign

                            </h3>



                            <dropdown class="w-[243px] h-[50px] border border-light-grey
                                    col-start-4 row-start-2 cursor-pointer"
                                  content-classes="w-[243px] bg-white"
                                  width="[240px]"
                                  align="left"
                                  type="text">


                                <template #trigger>


                                    <div class="mt-auto mb-[6px]">
                                        {{ placement.campaign_rule_name }}</div>


                                    <font-awesome-icon
                                        class="justify-center font-bold ml-auto my-auto w-[13px] h-[18px]"
                                        size="sm"
                                        :icon="['fas', 'caret-down']"/>


                                </template>


                                <template #content>


                                    <div class="hover:bg-grey py-2 px-4"
                                         :class="{
                                            'bg-grey': campaign_rule.name === placement.campaign_rule_name
                                        }"
                                        v-for="campaign_rule of campaign_rules"
                                        @click="handle_click_campaign_rule_id_for_ad_placement(
                                            campaign_rule, placement)">

                                        {{ campaign_rule.name }}

                                    </div>


                                </template>


                            </dropdown>


                            <dropdown class="w-[243px] h-[50px] border border-light-grey
                            col-start-6 row-start-2 cursor-pointer"
                                  content-classes="w-[243px] bg-white"
                                  width="[240px]"
                                  align="left"
                                  type="text">


                                <template #trigger>


                                    <div class="mt-auto mb-[6px]">

                                        {{ placement_as_text(placement.place) }}

                                    </div>


                                    <font-awesome-icon
                                        class="justify-center font-bold ml-auto my-auto w-[13px] h-[18px]"
                                        size="sm"
                                        :icon="['fas', 'caret-down']" />


                                </template>


                                <template #content>


                                    <div class="hover:bg-grey py-2 px-4"
                                        :class="{
                                            'bg-grey': placement.place === 'middle'
                                        }"
                                        @click="handle_click_place_for_ad_placement(
                                            'middle', placement)">Middle</div>


                                    <div class="hover:bg-grey py-2 px-4"
                                        :class="{
                                            'bg-grey': placement.place === 'bottom'
                                        }"
                                         @click="handle_click_place_for_ad_placement(
                                             'bottom', placement)">Bottom</div>


                                </template>


                            </dropdown>


                            <div class="items-center justify-self-end cursor-pointer
                                        flex col-start-[8] row-start-2"
                                 @click="handle_delete_placement(placement)">


                                <font-awesome-icon
                                    class="font-bold ml-auto my-auto mr-2 w-[14px] h-[14px] text-[#CE1515]"
                                    size="sm"
                                    :icon="['far', 'trash']" />


                                <h1 class="text-sm ml-1 font-nexa text-[#CE1515]">

                                    Delete Placement

                                </h1>


                            </div>


                        </div>


                        <div @click="create_new_placement" class="col-span-2 border-box mb-[15px] items-center
                             h-[115px] flex items-center justify-center cursor-pointer"
                             :style="`${dashed_background_svg}`">


                            <div class="h-[33px] w-[247px] flex">


                                <h3 class="mt-[3px]">

                                    Add campaign placement

                                </h3>


                                <font-awesome-icon
                                    class="text-blue font-bold ml-auto my-auto"
                                    style="height: 33px; width: 33px;"
                                    size="sm"
                                    :icon="['far', 'plus-circle']" />


                            </div>


                        </div>


                        <div class="p-2 my-4 bg-dark-blue items-center flex justify-center shadow-sm w-[155px] h-16 cursor-pointer"
                            @click="handle_click_save(form, route('ads'))">


                            <h1 class="ml-1 font-nexa text-white">

                                Save changes

                            </h1>


                        </div>


                        <div class="p-2 my-4 items-center place-self-end justify-self-end
                         self-center flex cursor-pointer"
                             @click="handle_delete_ad(form)">


                            <font-awesome-icon
                                class="font-bold ml-auto my-auto mr-2 w-[14px] h-[14px] text-[#CE1515]"
                                size="sm"
                                :icon="['far', 'trash']" />


                            <h1 class="text-sm ml-1 font-nexa text-[#CE1515]">

                                {{  (are_you_sure)
                                        ? 'Are you sure?'
                                        : 'Delete Ad in all Languages'
                                }}

                            </h1>


                        </div>


                    </div>


                </div>


            </div>


        </div>


    </app-layout>


</template>


<script>
import { defineComponent } from 'vue'
import AppLayout from '../Layouts/AppLayout.vue'
import NordenTable from "@/Components/NordenTable";
import { DialogOverlay } from "@headlessui/vue";
import { reactive } from 'vue'
import Dropdown from "@/Components/Dropdown";
import Editor from '@tinymce/tinymce-vue'
import RangePicker from "@/Components/RangePicker";
import FlashMessage from "@/Components/FlashMessage";
import Input from "@/Jetstream/Input";
import StatusComboBox from "@/Components/StatusComboBox";

export default defineComponent({

    components: {
        StatusComboBox,
        Input,
        FlashMessage,
        RangePicker,
        Dropdown,
        DialogOverlay,
        NordenTable,
        AppLayout,
        editor: Editor
    },

    props: {
        api_key: String,
        id: Number,
        ad_content_id: Number,
        updated_at: {
            type: String,
            default: '01 / 02 / 2022'
        },
        ad_title: String,
        title: String,
        languages: {
            type: Array,
            default: () => {
                return [
                    {
                    }
                ];
            }
        },
        languages_duplicatable: {
            type: Array,
            default: () => {
                return [
                    {
                        id: 1,
                        letter_code: 'en',
                        title: 'English'
                    }
                ];
            }
        },
        image: String,
        html: String,
        link: String,
        status: String,
        period: {
            type: Object,
            default() {
                return {
                    start_at: '',
                    end_at: ''
                }
            }
        },
        campaign_rules: {
            type: Array,
            default: () => {
                return [
                    {
                        id: 1,
                        name: 'Simple'
                    }
                ]
            }
        },
        placements: {
            type: Array,
            default: () => {
                return [
                    {
                        id: 1,
                        campaign_rule_id: 1,
                        campaign_rule_name: 'simple',
                        placement: 'middle',
                    },
                    {
                        id: 2,
                        campaign_rule_id: 1,
                        campaign_rule_name: 'compact',
                        placement: 'bottom',
                    }
                ];
            }
        },
        debug: String,
        current_language_id: Number,
        text_color: {
            type: String,
            default: ''
        },
        background_color: {
            type: String,
            default: ''
        },
        predefined_colors: {
            type: Array,
            default: () => {
                return [
                    {
                        id: 1,
                        name: 'Light Blue',
                        hex_name: '#d4e9f9',
                    },
                    {
                        id: 2,
                        name: 'Dark blue',
                        hex_name: '#385988',
                    },
                    {
                        id: 3,
                        name: 'Dark green',
                        hex_name: '#266d51',
                    },
                    {
                        id: 4,
                        name: 'Primary blue',
                        hex_name: '#006eb6',
                    },
                    {
                        id: 5,
                        name: 'Dark red',
                        hex_name: '#f42941',
                    },
                    {
                        id: 6,
                        name: 'Dark yellow',
                        hex_name: '#fdcf41',
                    },
                    {
                        id: 7,
                        name: 'Light violet',
                        hex_name: '#d3d5ed',
                    },
                    {
                        id: 8,
                        name: 'Light green',
                        hex_name: '#e2fae1',
                    },
                    {
                        id: 9,
                        name: 'Light red',
                        hex_name: '#fbdce7',
                    },
                    {
                        id: 10,
                        name: 'Light yellow',
                        hex_name: '#fff0be',
                    },
                    {
                        id: 11,
                        name: 'Light gray',
                        hex_name: '#ecedee',
                    },
                    {
                        id: 12,
                        name: '88 pct',
                        hex_name: '#454547',
                    },

                ]
            }
        },
        is_text_color_custom: false,
        is_background_color_custom: false,
        status_all: String,
        is_status_all_changed: false,
        organization: {
            type: String,
            default: 'the_nordic_council_of_ministers'
        }
    },


    data() {
        return {
            name: '',
            file: '',
            success: '',
            url: '',
            are_you_sure: false,
            are_you_sure_language: false,
            text_color_picker: this.text_color,
            background_color_picker: this.background_color,
        };

    },

    setup (props) {

        let form = reactive({
            ad_title: props.ad_title,
            title: props.title,
            id: props.ad_content_id,
            image: props.image,
            html: props.html,
            link: props.link,
            status: props.status,
            period: props.period,
            campaigns: props.placements,
            text_color: props.text_color ?? props.predefined_colors[0].hex_name,
            background_color: props.background_color ?? props.predefined_colors[0].hex_name,
            is_text_color_custom: props.is_text_color_custom,
            is_background_color_custom: props.is_background_color_custom,
            status_all: props.status_all,
            is_status_all_changed: props.is_status_all_changed,
            organization: props.organization,
        })

        function submit() {
            Inertia.post('/users', form)
        }

        return {
            form,
            submit
        }
    },


    computed: {

        dashed_background_svg()
        {
            return `background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23333' stroke-width='1' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");`
        },

        image_display() {

            if ( this.file ) {

                return this.url;

            }
            else if (this.form.image) {

                return this.form.image;

            }
            else {

                return this.$page.props.app.asset_url + '/images/ad-no-image.png';

            }

        },

        language_dropdown() {

            if (this.languages_duplicatable !== '') {

                return "2px 18px auto 18px";

            }

            return "";

        },


    },

    methods: {

        color_change(color, color_place) {

            if (color_place === 'text') {
                this.form.is_text_color_custom = false;
                this.form.text_color = color;
            } else {
                this.form.is_background_color_custom = false;
                this.form.background_color = color;
            }


        },

        custom_change(color_place) {

            if (color_place === 'text') {

                if (this.form.is_text_color_custom === true) {

                    this.form.is_text_color_custom = false;

                } else {

                    this.form.is_text_color_custom = true;

                }

            }
            if (color_place === 'background') {

                if (this.form.is_background_color_custom === true) {

                    this.form.is_background_color_custom = false;

                } else {

                    this.form.is_background_color_custom = true;

                }

            }

        },


        status_as_text(status) {

            if ( status === 'active' ) {

                return this.__('Active');

            }
            if ( status === 'paused' || ! status) {

                return this.__('Paused');

            }

            return this.__('New');

        },

        organization_as_text(organization) {

            if ( organization === 'the_nordic_council_of_ministers' ) {

                return this.__('The Nordic Council of Ministers');

            }
            if ( organization === 'the_nordic_council' ) {

                return this.__('The Nordic Council');

            }

            return this.__('Error: Unknown Organization');

        },

        handle_organization() {

            if ( this.form.organization === 'the_nordic_council_of_ministers' ) {

                this.form.organization = 'the_nordic_council';

            } else {

                this.form.organization = 'the_nordic_council_of_ministers';

            }

        },

        placement_as_text(name) {

            if ( name === 'middle' ) {

                return this.__('Middle');

            }
            if ( name === 'bottom') {

                return this.__('Bottom');

            }

            return this.__('No Placement')

        },

        handle_language_select(language) {

            this.$inertia.visit(
                this.route('ad', {
                    ad: language.ad_id,
                    language: language.src
                })
            )

        },

        handle_status() {

            if (this.form.status === 'active') {

                this.form.status = 'paused';

            } else {

                this.form.status = 'active';

            }

        },

        handle_all_status() {

            this.form.is_status_all_changed = true;

            if (this.form.status_all === 'active') {

                this.form.status_all = 'paused'

            } else {

                this.form.status_all = 'active'

            }

        },



        onFileChange(e){

            this.file = e.target.files[0];

            this.url = URL.createObjectURL(this.file);

        },


        image_upload(e) {

            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }


            let formData = new FormData();

            formData.append('file', this.file);


            axios.post(`/ads/${this.id}/contents/${this.ad_content_id}/image`, formData, config)
                .then(function (response) {
                })
                .catch(function (error) {

                    console.error(error);

                });

        },


        create_new_placement() {

            this.$inertia.post(
                this.route('placement_create', {
                    ad: this.id,
                    language: this.current_language_id
                }),
                {
                    preserveScroll: true,
                    onSuccess: this.reload_placements
                }
            );

        },

        handle_click_duplicate_to_new_language(language) {

            this.$inertia.post(
                this.route('ad', {
                    ad: this.id,
                    language: this.current_language_id,
                }),
                {
                    preserveScroll: false,
                    duplicate_to_language: language.id,
                }
            );

        },

        handle_click_campaign_rule_id_for_ad_placement(campaign_rule,placement) {

            this.$inertia.patch(
                this.route('placement_update', {
                    ad: this.id,
                    ad_placement: placement.id,
                }),
                {
                    field: 'campaign_rule_id',
                    value: campaign_rule.id,
                    preserveScroll: true,
                }
            );

        },

        handle_click_place_for_ad_placement(place, placement) {

            this.$inertia.patch(
                this.route('placement_update', {
                    ad: this.id,
                    ad_placement: placement.id,
                }),
                {
                    field: 'place',
                    value: place,
                    preserveScroll: true,
                }
            );

        },

        handle_click_save(form, redirect) {

            if (this.file) {

                this.image_upload();

            }

            if (form.is_text_color_custom === true) {

                form.text_color = this.text_color_picker;

            }

            if (form.is_background_color_custom === true) {

                form.background_color = this.background_color_picker;

            }

            this.$inertia.put(
                this.route('ad_content_save', {
                    ad: this.id,
                    ad_content: this.ad_content_id,
                }),
                {
                    ad_title: form.ad_title,
                    status: form.status,
                    title: form.title,
                    id: form.id,
                    image_url: form.image,
                    html: form.html,
                    link: form.link,
                    start_at: form.period.start_at,
                    end_at: form.period.end_at,
                    text_color: form.text_color,
                    background_color: form.background_color,
                    is_text_color_custom: form.is_text_color_custom,
                    is_background_color_custom: form.is_background_color_custom,
                    status_all: form.status_all,
                    is_status_all_changed: form.is_status_all_changed,
                    preserveScroll: false,
                    organization: form.organization,
                },
                {
                    onSuccess: () => {
                        this.$inertia.visit(redirect);
                    }
                }
            );

        },

        handle_period_start_change(start_at) {

            this.form.period.start_at = start_at;

        },

        handle_period_end_change(end_at) {

            this.form.period.end_at = end_at;

        },

        handle_delete_language() {

            if ( ! this.are_you_sure_language ) {

                this.are_you_sure_language = true;

                return;


            }

            this.are_you_sure_language = false;

            this.$inertia.delete(
                this.route('ad_content_delete', {
                    ad: this.id,
                    ad_content: this.ad_content_id,
                }),
                {
                    preserveScroll: () => false,
                    onSuccess: (page) => {

                        if (page.component === 'Ad') {
                            this.$inertia.visit(
                                this.route('ad_parent', {
                                    ad: this.id
                                }),
                                {
                                    preserveScroll: false
                                }
                            )
                        }
                    }
                }
            );
        },

        handle_delete_placement(placement) {

            this.$inertia.delete(
                this.route('placement_delete', {
                    ad: this.id,
                    ad_placement: placement,
                }),
                {
                    preserveScroll: true,
                }
            );

        },

        handle_delete_ad() {

            if ( ! this.are_you_sure ) {

                this.are_you_sure = true;

                return;

            }

            this.are_you_sure = false;


            this.$inertia.delete(
                this.route('ad_delete', {
                    ad: this.id,
                }),
                {
                    preserveScroll: true,
                    onSuccess: () => {
                        this.$inertia.visit(
                            this.route('ads', {
                                ad: this.id
                            }),
                            {
                                preserveScroll: false
                            }
                        )

                    }

                }

            );

        },


        handle_click_delete_image() {

            axios.delete(
                this.route('ad_content_image_delete', {
                    ad: this.id,
                    ad_content: this.ad_content_id
                }),
            ).then((response) => {

                this.form.image = '';

                this.file = false;

            })
            .catch((error) => {

                console.error(error);

            });

        },


        handle_click_on_preview() {

            window.open(
                this.route('newsletter_preview', {
                    type: 'compact',
                    ad_content_id: this.ad_content_id,
                    language_id: this.current_language_id
                })
                , '_blank'
            );

        }

    }

})
</script>
